import React, {useEffect, useState} from "react";
import {
    Button,
    Card,
    Heading,
    Table,
    Td,
    Th,
    Image,
    Flex,
    Text,
    OpenNewIcon,
    Link,
    Toggle,
    ButtonMenu,
    ButtonMenuItem, Input
} from "uikit"
import Page from "views/Page"
import {useTranslation} from "../../contexts/Localization";
import {useLockContract} from "../../hooks/useContract";
import {useWeb3React} from "@web3-react/core";
import BigNumber from "bignumber.js";
import Toast from "../../components/Toast/Toast";
import {getFullDisplayBalance} from "../../utils/formatBalance";
import multicall from "../../utils/multicall";
import erc20Abi from "../../config/abi/erc20.json";
import _ from "lodash";
import styled from "styled-components";
import RcPagination from "rc-pagination";
import {getBep20Contract} from "../../utils/contractHelpers";
import {getProviderOrSigner} from "../../utils";

const StyledLink = styled(Link)`
  display: inline;
  font-size: 14px;
`

const StyledInput = styled(Input)`
  border-radius: 16px;
  margin-left: auto;
  color:#ffffff;
`

const InputWrapper = styled.div`
  width: 100%;
  ${({ theme }) => theme.mediaQueries.sm} {
    display: block;
  }
`

export default function SelfLockToken() {
    const { t } = useTranslation();
    const { account, library } = useWeb3React()
    const lockContract = useLockContract();

    const [searchText,setSearchText] = useState('')
    const [activeIndex,setActiveIndex] = useState(0);
    const [myLockDataLoad,setMyLockDataLoad] = useState(false);
    const [myLockData,setMyLockData] = useState([]);
    const [totalLockCount,setTotalLockCount] = useState(0);
    const [lockData,setLockData] = useState([]);
    const [firstLockDataLoad,setFirstLockDataLoad] = useState(false);
    const [pages, setPages] = useState({
        page:1,
        pageSize: 20,
    })

    const onChangeIndex = (isAnother) => {
        setActiveIndex(isAnother)
    }

    const getMyLock = async () => {
        const myLocks = await lockContract.normalLocksForUser(account);
        const callsName = myLocks.map((item) => {
            return {
                address: item.token,
                name: 'name',
                params: [],
            }
        });
        const callsSymbol = myLocks.map((item) => {
            return {
                address: item.token,
                name: 'symbol',
                params: [],
            }
        });
        const callsDecimal = myLocks.map((item) => {
            return {
                address: item.token,
                name: 'decimals',
                params: [],
            }
        })

        const rawNames = await multicall(erc20Abi, callsName);
        const rawSymbols = await multicall(erc20Abi, callsSymbol);
        const rawDecimals = await multicall(erc20Abi, callsDecimal);

        let result = [];
        for(let i=0;i<myLocks.length;i++){
            let obj = _.clone(myLocks[i]);
            obj.push(rawNames[i][0]);
            obj.push(rawSymbols[i][0]);
            obj.push(rawDecimals[i][0]);
            result.push(obj);
        }
        result.reverse();
        setMyLockData(result);
        setMyLockDataLoad(true);
    }

    const getFirstLock = async () => {
        setFirstLockDataLoad(true);
        const locksCount = await lockContract.allNormalTokenLockedCount();
        setTotalLockCount(locksCount);
        const lockFirst = await lockContract.getCumulativeNormalTokenLockInfo(0,19);

        const callsName = lockFirst.map((item) => {
            return {
                address: item.token,
                name: 'name',
                params: [],
            }
        });
        const callsSymbol = lockFirst.map((item) => {
            return {
                address: item.token,
                name: 'symbol',
                params: [],
            }
        });
        const callsDecimal = lockFirst.map((item) => {
            return {
                address: item.token,
                name: 'decimals',
                params: [],
            }
        })
        const rawNames = await multicall(erc20Abi, callsName);
        const rawSymbols = await multicall(erc20Abi, callsSymbol);
        const rawDecimals = await multicall(erc20Abi, callsDecimal);

        let result = [];
        for(let i=0;i<lockFirst.length;i++){
            let obj = _.clone(lockFirst[i]);
            obj.push(rawNames[i][0]);
            obj.push(rawSymbols[i][0]);
            obj.push(rawDecimals[i][0]);
            result.push(obj);
        }
        setLockData(result);
    }

        // @ts-ignore
    useEffect(async () => {
        if(!myLockDataLoad){
            getMyLock();
        }
        if(!firstLockDataLoad){
            getFirstLock();
        }
    },[lockContract,account,getMyLock,myLockDataLoad,firstLockDataLoad,getFirstLock]);

    const changePages = async page => {
        let newObj = Object.assign({}, pages);
        newObj.page = page;
        setPages(newObj);
        setLockData([]);
        let indexP = page - 1;
        let startP = indexP * 20;
        let endP = startP + 19;
        const lockFirst = await lockContract.getCumulativeNormalTokenLockInfo(startP, endP);
        const callsName = lockFirst.map((item) => {
            return {
                address: item.token,
                name: 'name',
                params: [],
            }
        });
        const callsSymbol = lockFirst.map((item) => {
            return {
                address: item.token,
                name: 'symbol',
                params: [],
            }
        });
        const callsDecimal = lockFirst.map((item) => {
            return {
                address: item.token,
                name: 'decimals',
                params: [],
            }
        })
        const rawNames = await multicall(erc20Abi, callsName);
        const rawSymbols = await multicall(erc20Abi, callsSymbol);
        const rawDecimals = await multicall(erc20Abi, callsDecimal);

        let result = [];
        for(let i=0;i<lockFirst.length;i++){
            let obj = _.clone(lockFirst[i]);
            obj.push(rawNames[i][0]);
            obj.push(rawSymbols[i][0]);
            obj.push(rawDecimals[i][0]);
            result.push(obj);
        }
        setLockData(result);
    }

    const onSearch = async (event: React.ChangeEvent<HTMLInputElement>) => {
        setSearchText(event.target.value);
        if(event.target.value == ''){
            changePages(1);
            return;
        }
        try{
            const lockFirst = await lockContract.cumulativeLockInfo(event.target.value);
            const contract = getBep20Contract(lockFirst[0], getProviderOrSigner(library, account));
            const symbol = await contract.symbol();
            const name = await contract.name();
            const decimals = await contract.decimals();
            let obj = _.clone(lockFirst);
            obj.push(name);
            obj.push(symbol);
            obj.push(decimals);
            setLockData([obj]);
        }catch (e) {

        }
    }

    return <>
        <Page style={{margin:0}}>
            <Card style={{ width: '100%', maxWidth: '663px' }} padding="2.4rem 2rem">
                {activeIndex == 0?
                    <InputWrapper>
                        <StyledInput value={searchText} onChange={onSearch} placeholder={t('Search by token Address')} />
                    </InputWrapper>
                    :
                    <div/>
                }
                <div style={{marginTop:20,width:'100%',display:'flex',flexDirection:'row',alignItems:'flex-end',justifyContent:'flex-end'}}>
                    <ButtonMenu onItemClick={(index)=>onChangeIndex(index)} activeIndex={activeIndex} scale="sm" variant="subtle">
                        <ButtonMenuItem id="swap-nav-link" as="a">
                            {t('All')}
                        </ButtonMenuItem>
                        <ButtonMenuItem  id="pool-nav-link" as="a">
                            {t('My Lock')}
                        </ButtonMenuItem>
                    </ButtonMenu>
                </div>
                <div style={{width:'100%',marginTop:20,marginBottom:20,display:'flex',flexDirection:'row',alignItems:'center',justifyContent:'space-between'}}>
                    <div>{t('Token')}</div>
                    <div>{t('Amount')}</div>
                    <div style={{width:25}}/>
                </div>
                {
                    activeIndex == 1?
                        <div>
                            {myLockData.map((item, index) => {
                                return (
                                    <div>
                                        <div key={index} style={{width:'100%',height:70,display:'flex',flexDirection:'row',alignItems:'center',justifyContent:'space-between'}}>
                                            <div style={{flex:1}}>
                                                <div>{item[11]}</div>
                                                <div style={{marginTop:5}}>{item[12]}</div>
                                            </div>
                                            <div style={{flex:1}}>{getFullDisplayBalance(new BigNumber(item[3].toString()),item[13],3)}</div>
                                            <div >
                                                <StyledLink href={'/selfLock/record/'+item[0]}>View</StyledLink>
                                            </div>
                                        </div>
                                        <div style={{width:'100%',height:1,background:'#000'}}/>
                                    </div>
                                )
                            })}
                        </div>:
                        <div>
                            {lockData.map((item, index) => {
                                return (
                                    <div>
                                        <div key={index} style={{width:'100%',height:70,display:'flex',flexDirection:'row',alignItems:'center',justifyContent:'space-between'}}>
                                            <div style={{flex:1}}>
                                                <div>{item[3]}</div>
                                                <div style={{marginTop:5}}>{item[4]}</div>
                                            </div>
                                            <div style={{flex:1}}>{getFullDisplayBalance(new BigNumber(item[2].toString()),item[5],3)}</div>
                                            <div >
                                                <StyledLink href={'/selfLock/detail/'+item[0]}>View</StyledLink>
                                            </div>
                                        </div>
                                        <div style={{width:'100%',height:1,background:'#000'}}/>
                                    </div>
                                )
                            })}
                            <Flex style={{paddingRight:'27px', marginTop:'20px'}} justifyContent="flex-end">
                                <RcPagination current={pages.page} total={totalLockCount} pageSize={pages.pageSize} onChange={page => changePages(page)} hideOnSinglePage />
                            </Flex>
                        </div>
                }
            </Card>
        </Page>
    </>
}